import React from 'react';
import { Typography } from 'antd';
import { ShiftsAddMultipleReviewErrors } from './shifts-add-multiple-review-errors';
import { ContentContainer, Icon } from '@common/components';
import { ImportShift } from '@scheduling/graphql';
import { CSVError } from 'works/legacy/lib/csv_error';
import { ShiftsAddMultipleReviewTable } from './shifts-add-multiple-review-table';

const { Text } = Typography;

type Props = {
  importShifts: ImportShift[];
  errors: CSVError[];
};

export function ShiftsAddMultipleReview({ importShifts, errors }: Props) {
  const shiftsCounter = importShifts.length;

  const relativeText = shiftsCounter > 1 ? 'shifts are' : 'shift is';

  return (
    <>
      {!errors.length ? (
        <ContentContainer
          title="Review shifts to import"
          header={
            <Text>
              {shiftsCounter} {relativeText} ready to be imported.
            </Text>
          }
        >
          <ShiftsAddMultipleReviewTable importShifts={importShifts} />
        </ContentContainer>
      ) : (
        <ContentContainer
          title={
            <>
              <Icon icon="ban" kind="regular" color="coral" size="xl" />
              This file can&apos;t be uploaded
            </>
          }
          header={
            <Text>
              Correct the errors below and go back to upload the updated file
              when ready.
            </Text>
          }
        >
          <ShiftsAddMultipleReviewErrors errors={errors} />
        </ContentContainer>
      )}
    </>
  );
}
